module.exports = __webpack_public_path__ + "static/img/14.b438f55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/14.jpg
// module id = ty0Z
// module chunks = 1